import { ofType } from "redux-observable";
import { mergeMap, debounceTime } from "rxjs/operators";
import { merge, of } from "rxjs";

import { GET_WATCH_LIST_ENTRIES_HIGH_RISK_COUNTRIES } from "../types";
import { WATCH_LIST_ENTRY_MESSAGES } from "../constants/watchListEntryMessages";
import {
  getWatchListEntriesPending,
  getWatchListEntriesFulfilled,
  getWatchListEntriesRejected,
  setRiskNoEntriesMessage,
} from "../actions";
import { sendApiRequest, notifyError } from "../../../actions";
import { watchListEntriesFiltersSelector } from "../selectors";
import generateError from "../../../utilities/generateError";

const createPayload = (payload) => ({
  method: "get",
  url: "watchlistentryhighriskcountries/get",
  onSuccess: [
    (response) =>
      response.data.length === 0
        ? setRiskNoEntriesMessage(WATCH_LIST_ENTRY_MESSAGES.NOT_FOUND)
        : getWatchListEntriesFulfilled(response),
  ],
  onError: [
    getWatchListEntriesRejected,
    (error) => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: "ajaxApi",
};

const getWatchListEntriesEpic$ = (action$, state$) =>
  action$.pipe(
    ofType(GET_WATCH_LIST_ENTRIES_HIGH_RISK_COUNTRIES.DEFAULT),
    debounceTime(500),
    mergeMap(({ payload }) => {
      const filters = watchListEntriesFiltersSelector(state$.value);

      return merge(
        of(getWatchListEntriesPending()),
        of(sendApiRequest(createPayload({ ...payload, ...filters }), meta))
      );
    })
  );

export default getWatchListEntriesEpic$;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry-high-risk-country/epics/getWatchListEntriesEpic.js